import { httpClient } from '#shared'
import type { AddAttachmentResponse } from '../model/add-attachment-response'

export async function addAttachment(file: File) {
  const response = await httpClient.post<AddAttachmentResponse>('attachments', {
    body: file,
    requireAuth: true,
  })

  const responseBody = await response.json()

  return responseBody
}
